import { httpUrl } from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-lease`
let baseUrl15 = `${httpUrl.host}/gy-electric`
let baseUrl3 = `${httpUrl.host}/gy-finance`
let baseUrl4 = `${httpUrl.host}/gy-message`
let baseUrl5 = `${httpUrl.host}/gy-water`
let baseUrl6 = `${httpUrl.host}/gy-hatch`
let baseUrl7 = `${httpUrl.host}/gy-attendance`
let baseUrl8 = `${httpUrl.host}/gy-parking`
let baseUrl9 = `${httpUrl.host}/gy-zqht`
let baseUrl10 = `${httpUrl.host}/gy-steam`
let baseUrl11 = `${httpUrl.host}/gy-gas`
let baseUrl12 = `${httpUrl.host}/gy-apartment`
let baseUrl13 = `${httpUrl.host}/gy-interaction`
let baseUrl14 = `${httpUrl.host}/gy-agent`

let api = {
  // 我发起的
  getPageBySponsorAccountCode: `${baseUrl2}/contractApprove/getPageBySponsorAccountCode`,

  // 0-待我审批   1-我已审批
  getPageByApproveAccountCode: `${baseUrl2}/contractApprove/getPageByApproveAccountCode`,

  // 审批通过
  passSubmit: `${baseUrl2}/contractApprove/passSubmit`,

  // 审批驳回
  unpassSubmit: `${baseUrl2}/contractApprove/unpassSubmit`,

  // 审批加签
  submitAgain: `${baseUrl2}/contractApprove/submitAgain`,

  // 获取审批人
  getAccountListByCode: `${baseUrl2}/contractApprove/getAccountListByCode`,

  // 获取合同详情
  getContractByCode: `${baseUrl2}/contractManager/getByCode`,

  // 撤回
  recallContract: `${baseUrl2}/contractApprove/recall`,

  // 查看退租协议
  getSurrenderContractDetailByContractCode: `${baseUrl2}/contractApprove/getSurrenderContractDetailByContractCode`,

  // 查询历史账单
  getListByContractCode: `${baseUrl2}/payItemDetail/getListByContractCode`,

  // 其他合同       获取合同详情
  getOtherContractManagerByCode: `${baseUrl2}/otherContractManager/getByCode`,

  // 其他合同       驳回
  unpassSubmitOtherContractManagerByCode: `${baseUrl2}/otherContractApprove/unpassSubmit`,

  // 其他合同       通过
  passSubmitOtherContractManagerByCode: `${baseUrl2}/otherContractApprove/passSubmit`,

  // 其他合同       查询历史账单
  getOtherPayItemDetailListByContractCode: `${baseUrl2}/otherPayItemDetail/getListByContractCode`,

  // 其他合同       撤回
  recallOtherContractApprove: `${baseUrl2}/otherContractApprove/recall`,

  // 电费审批
  getElectricApprovePage: `${baseUrl15}/electricApprove/getPage`,

  // 电费审批通过
  passElectricApprove: `${baseUrl15}/electricApprove/pass`,

  // 电费审批驳回
  unPassElectricApprove: `${baseUrl15}/electricApprove/unpass`,

  // 水费审批
  getWaterApprovePage: `${baseUrl5}/waterApprove/getPage`,

  // 水费审批通过
  passWaterApprove: `${baseUrl5}/waterApprove/pass`,

  // 水费审批驳回
  unPassWaterApprove: `${baseUrl5}/waterApprove/unpass`,

  // 蒸汽审批
  getSteamApprovePage: `${baseUrl10}/steamApprove/getPage`,

  // 蒸汽审批通过
  passSteamApprove: `${baseUrl10}/steamApprove/pass`,

  // 蒸汽审批驳回
  unPassSteamApprove: `${baseUrl10}/steamApprove/unpass`,

  // 燃气审批
  getGasApprovePage: `${baseUrl11}/gasApprove/getPage`,

  // 燃气审批通过
  passGasApprove: `${baseUrl11}/gasApprove/pass`,

  // 燃气审批驳回
  unPassGasApprove: `${baseUrl11}/gasApprove/unpass`,

  // 账单审批
  getBillApprovePage: `${baseUrl3}/billApprove/getPage`,

  // 账单审批
  passBillApprove: `${baseUrl3}/billApprove/pass`,

  // 账单审批驳回
  unpassBillApprove: `${baseUrl3}/billApprove/unpass`,

  // 获取投诉建议分页
  getSuggestionsPage: `${baseUrl4}/suggestions/getPage`,

  // 获得当前账号 和 他的上级账号列表
  getHatchAccountListByCode: `${baseUrl6}/protocolApprove/getAccountListByCode`,

  // 我发起的(孵化)
  getHatchPageBySponsorAccountCode: `${baseUrl6}/protocolApprove/getPageBySponsorAccountCode`,

  // 待我审批(孵化)
  getHatchPageByApproveAccountCode: `${baseUrl6}/protocolApprove/getPageByApproveAccountCode`,

  // 审批通过(孵化)
  protocolApprovePassSubmit: `${baseUrl6}/protocolApprove/passSubmit`,

  // 审批驳回(孵化)
  protocolApproveUnPassSubmit: `${baseUrl6}/protocolApprove/unPassSubmit`,

  // 查看孵化协议详情
  getHatchProtocolByCode: `${baseUrl6}/hatchProtocol/getByCode`,

  // 考勤我发起的
  getAttendanceApprovePageBySponsorAccountCode: `${baseUrl7}/attendanceApprove/getPageBySponsorAccountCode`,

  // 考勤审批分页
  getAttendanceApprovePageByApproveAccountCode: `${baseUrl7}/attendanceApprove/getPageByApproveAccountCode`,

  // 考勤审批通过
  passSubmitAttendanceApprove: `${baseUrl7}/attendanceApprove/passSubmit`,

  // 考勤审批驳回
  unPassSubmitAttendanceApprove: `${baseUrl7}/attendanceApprove/unPassSubmit`,

  //车位申请分页
  getApprovalPendingByAdmin: `${baseUrl8}/parkingLotApply/getApprovalPendingByAdmin`,

  //车位申请完成分页
  getApplyFinishByAdmin: `${baseUrl8}/parkingLotApply/getApplyFinishByAdmin`,

  //同意申请
  agreeApplyLease: `${baseUrl8}/parkingLotApply/agreeApplyLease`,

  //驳回申请
  rejectApplyLease: `${baseUrl8}/parkingLotApply/returnDownApply`,

  //车位退还分页
  getDisapprovalPendingByAdmin: `${baseUrl8}/parkingLotApplyReturn/selectApprovalPending`,

  //同意退还申请
  agreeApplyReturn: `${baseUrl8}/parkingLotApplyReturn/agreeApplyReturn`,

  //驳回退还申请
  returnDownApplyReturn: `${baseUrl8}/parkingLotApplyReturn/returnDownApplyReturn`,

  //车位退还完成分页
  getSelectFinishByAdmin: `${baseUrl8}/parkingLotApplyReturn/selectFinish`,

  // 获取车位退还详情
  getReturnByCode: `${baseUrl8}/parkingLotApplyReturn/getByCode`,

  // 获取车位申请详情
  getApplyByCode: `${baseUrl8}/parkingLotApply/getByCode`,

  // 车位区域列表
  getParkingLotAreaList: `${baseUrl8}/parkingLotArea/getAllParkingLotArea`,

  // 车位信息列表
  getParkingLotList: `${baseUrl8}/parkingLot/getList`,

  // 查询金额配置列表
  getParkingPaymentConfigList: `${baseUrl8}/parkingPaymentConfig/getParkingPaymentConfigList`,

  // 数据上报审批——我发起的
  getApproveChainBySponsor: `${baseUrl9}/approveChain/getListBySponsor`,

  // 数据上报审批——0-待我审批   1-我已审批
  getApproveChainByPage: `${baseUrl9}/approveChain/getByPage`,

  // 数据上报审批——驳回
  rejectApproveChain: `${baseUrl9}/approveChain/reject`,

  // 数据上报审批——通过
  consentApproveChain: `${baseUrl9}/approveChain/consent`,

  // 数据上报审批——获取审批数据详情
  getUploadParam: `${baseUrl9}/approveChain/getUploadParam`,

  //免费码授权人审批——待我审批
  getOtherConfigApprovePage: `${baseUrl8}/otherConfig/getApprovePage`,

  //免费码授权人审批——审批通过
  agreeAuthorizerApply: `${baseUrl8}/otherConfig/agreeAuthorizerApply`,

  //免费码授权人审批——审批驳回
  rejectAuthorizerApply: `${baseUrl8}/otherConfig/rejectAuthorizerApply`,

  //免费码授权人审批——我发起的
  getOtherConfigApplyPage: `${baseUrl8}/otherConfig/getApplyPage`,

  //免费码授权人审批——撤回
  applyCallback: `${baseUrl8}/otherConfig/applyCallback`,

  //免费码审批进度
  getApplyFlow: `${baseUrl8}/otherConfig/getApplyFlow`,

  //考勤审批进度
  getAttendanceApproveFlow: `${baseUrl7}/attendanceApprove/getApplyFlow`,

  //电费审批进度
  getElectricApproveFlow: `${baseUrl15}/electricApprove/getApplyFlow`,

  // 水费审批进度
  getWaterApproveFlow: `${baseUrl5}/waterApprove/getApplyFlow`,

  // 蒸汽审批进度
  getSteamApproveFlow: `${baseUrl10}/steamApprove/getApplyFlow`,

  // 燃气审批进度
  getGasApproveFlow: `${baseUrl11}/gasApprove/getApplyFlow`,

  //车位申请审批进度
  getParkingLotApplyFlow: `${baseUrl8}/parkingLotApply/getApplyFlow`,

  //车位退还审批进度
  getParkingLotApplyReturnFlow: `${baseUrl8}/parkingLotApplyReturn/getApplyFlow`,

  // 孵化审批进度
  getProtocolApproveFlow: `${baseUrl6}/protocolApprove/getApplyFlow`,

  // 合同审批进度
  getContractApproveFlow: `${baseUrl2}/contractApprove/getApplyFlow`,

  // 数据上报审批进度
  getApproveChainFlow: `${baseUrl9}/approveChain/getApplyFlow`,

  // 账单修改审批进度
  getBillApproveFlow: `${baseUrl3}/billApprove/getApplyFlow`,

  // 查看更多版本
  getVesionList: `${baseUrl12}/homePage/getVesionList`,

  // 入住申请审批——获取待审批数据
  getStayApplyApprovalPendingByAdmin: `${baseUrl}/stayApply/getApprovalPendingByAdmin`,

  // 入住申请审批——获取我已审批数据
  getStayApplyApplyFinishByAdmin: `${baseUrl}/stayApply/getApplyFinishByAdmin`,

  // 入住申请审批——获取我发起的数据
  getStayApplyByInitiate: `${baseUrl}/stayApply/getByInitiate`,

  // 入住申请审批——查询申请详情
  getStayApplyByCode: `${baseUrl}/stayApply/getByCode`,

  // 入住申请审批——申请通过
  agreeApprovalNodeApply: `${baseUrl}/approvalNode/agreeApply`,

  // 入住申请审批——申请驳回
  rejectApprovalNodeApply: `${baseUrl}/approvalNode/rejectApply`,

  // 入住申请审批——查看审批进度
  getStayApplyApplyFlow: `${baseUrl}/stayApply/getApplyFlow`,

  // 报修申请分页
  getRepairApplyPage: `${baseUrl13}/repairApply/getApplyPage`,

  // 报修审批——审批通过
  agreeRepairApply: `${baseUrl13}/repairApply/agreeApply`,

  // 报修审批——审批驳回
  rejectRepairApply: `${baseUrl13}/repairApply/rejectApply`,

  // 报修审批进度
  getRepairApplyFlow: `${baseUrl13}/repairApply/getApplyFlow`,
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/WorkbenchApproval.js